import type { ReactNode } from 'react';

const bulletStyle = { fontSize: '1.2em', verticalAlign: '0.02em' } as const;

/**
 * Wraps runs of bullet characters (•) in spans with adjusted vertical alignment
 * so they sit on the same baseline as adjacent digits and letters.
 */
export const renderScrubbedText = (text: string): ReactNode => {
  const parts = text.split(/(•+)/);
  if (parts.length === 1) return text;
  let offset = 0;
  return parts.map(part => {
    const start = offset;
    offset += part.length;
    return part.includes('•') ? (
      <span key={start} style={bulletStyle}>
        {part}
      </span>
    ) : (
      part
    );
  });
};
